export default __webpack_public_path__ + "static/media/alimento.34490020.png";